import type { SwingParams } from '../types';

/** All baseline shots contribute equally; keep the player's directional bias.
 * Averaged launch is a representative shot, not a dispersion distribution. */
export function averageBaselineDelivery(shots: readonly SwingParams[]): SwingParams | null {
  if (!shots.length) return null;
  const reference = { ...shots[0] };
  const keys = ['clubSpeed', 'ballSpeed', 'launchAngle', 'launchDirection', 'spinRate',
    'spinAxis', 'attackAngle', 'clubPath', 'faceAngle'] as const;
  for (const key of keys) {
    reference[key] = shots.reduce((sum, shot) => sum + shot[key], 0) / shots.length;
  }
  return reference;
}
